<template>
  <div id="editor">
    <div v-if="loading">Loading...</div>
    <div v-else>
      <div v-html="website == null ? '' : website.htmlContent"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";

export default {
  computed: {
    ...mapGetters("websiteBuilderModule", {
      website: "website",
      loading: "loading",
    }),
  },

  methods: {
    ...mapActions("websiteBuilderModule", [
      "getWebsiteAction",
      "updateWebsitebuildersAction",
    ]),

    showLoaderPopup() {
      Swal.fire({
        title: "Saving...",
        text: "Please wait while we save your content.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
    },

    showSuccessPopup() {
      Swal.fire({
        title: "Website Updated!",
        text: "You have successfully updated the website.",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
          
        },
        buttonsStyling: false,
      });
    },

    showErrorPopup() {
      Swal.fire({
        title: "Error!",
        text: "Failed to update website.",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
  },

  async mounted() {
    await this.getWebsiteAction();
    //Check (Step 1) for testing (In case new issue encountered)
    //console.log("Website content loaded:", this.website?.htmlContent?.substring(0, 200));

    // Wait for Vue to render the content before initializing GrapesJS
    await this.$nextTick();

    const editor = grapesjs.init({
      container: "#editor",
      fromElement: true,
      plugins: ["grapesjs-preset-newsletter"],
      pluginsOpts: {
        "grapesjs-preset-newsletter": {
          // options
        },
      },
      width: "auto",
      height: "100vh",
      storageManager: { autoload: 0 },
    });
    
    //check (step 2)
    //console.log("Editor initialized, components:", editor.getComponents().length);

    // Add Save button to the panel
    editor.Panels.addButton("options", {
      id: "save-button",
      className: "fa fa-save", // Save icon
      command: "save-command",
      attributes: { title: "Save" },
    });

    // Add Upload button to the panel
    editor.Panels.addButton("options", {
      id: "upload-button",
      className: "fa fa-upload", // Upload icon
      command: "upload-command",
      attributes: { title: "Upload" },
    });



    //SD TO TEST
    var pfx = editor.getConfig().stylePrefix
    var modal = editor.Modal
    var cmdm = editor.Commands
    var htmlCodeViewer = editor.CodeManager.getViewer('CodeMirror').clone()
    var cssCodeViewer = editor.CodeManager.getViewer('CodeMirror').clone()
    var pnm = editor.Panels
    var container = document.createElement('div')
    var btnEdit = document.createElement('button')

    htmlCodeViewer.set({
      codeName: 'htmlmixed',
      readOnly: 0,
      theme: 'hopscotch',
      autoBeautify: true,
      autoCloseTags: true,
      autoCloseBrackets: true,
      lineWrapping: true,
      styleActiveLine: true,
      smartIndent: true,
      indentWithTabs: true
    })

    cssCodeViewer.set({
      codeName: 'css',
      readOnly: 0,
      theme: 'hopscotch',
      autoBeautify: true,
      autoCloseTags: true,
      autoCloseBrackets: true,
      lineWrapping: true,
      styleActiveLine: true,
      smartIndent: true,
      indentWithTabs: true
    })

    btnEdit.innerHTML = 'Save'
    btnEdit.className = pfx + 'btn-prim ' + pfx + 'btn-import'
    btnEdit.onclick = function () {
      var html = htmlCodeViewer.editor.getValue()
      var css = cssCodeViewer.editor.getValue()
      editor.DomComponents.getWrapper().set('content', '')
      editor.setComponents(html.trim())
      editor.setStyle(css)
      modal.close()
    }

    cmdm.add('edit-code', {
      run: function (editor, sender) {
        sender && sender.set('active', 0)
        var htmlViewer = htmlCodeViewer.editor
        var cssViewer = cssCodeViewer.editor
        modal.setTitle('Edit code')
        if (!htmlViewer && !cssViewer) {
          var txtarea = document.createElement('textarea')
          var cssarea = document.createElement('textarea')
          container.appendChild(txtarea)
          container.appendChild(cssarea)
          container.appendChild(btnEdit)
          htmlCodeViewer.init(txtarea)
          cssCodeViewer.init(cssarea)
          htmlViewer = htmlCodeViewer.editor
          cssViewer = cssCodeViewer.editor
        }
        var InnerHtml = editor.getHtml()
        var Css = editor.getCss()
        modal.setContent('')
        modal.setContent(container)
        htmlCodeViewer.setContent(InnerHtml)
        cssCodeViewer.setContent(Css)
        modal.open()
        htmlViewer.refresh()
        cssViewer.refresh()
      }
    })

    pnm.addButton('options',
      [
        {
          id: 'edit',
          className: 'fa fa-edit',
          command: 'edit-code',
          attributes: {
            title: 'Edit Code'
          }
        }
      ]
    )

    // Save command
    editor.Commands.add("save-command", {
      run: async () => {
        this.showLoaderPopup(); // Show loading popup

        // Get HTML and CSS separately
        const html = editor.getHtml();
        const css = editor.getCss();
        
        // Combine them in a format that works with fromElement: true
        const htmlWithCss = `<style>${css}</style>${html}`;
        
        //check (step 3)
        //console.log("Saving HTML length:", htmlWithCss.length);

        let payload = {
          id: this.website.id,
          htmlContent: htmlWithCss,
          isActive: true,
          websiteStatus: this.website.websiteStatus,
          urlPath: this.website.urlPath,
          pageName: this.website.pageName,
        };

        try {
          await this.updateWebsitebuildersAction(payload);
          Swal.close(); // Close loading popup
          this.showSuccessPopup();
        } catch (error) {
          console.error(error);
          Swal.close(); // Close loading popup
          this.showErrorPopup();
        }
      },
    });
  },
};
</script>
